import {
    USER_SEGMENTS_REQUESTED,
    MORE_USER_SEGMENTS_REQUESTED,
    USER_SEGMENTS_SUCCEEDED,
    USER_SEGMENTS_FAILED,
    SEGMENT_TAGS_REQUESTED,
    SEGMENT_TAGS_SUCCEEDED,
    SEGMENT_TAGS_FAILED,
    SET_ACTIVE_SEGMENT,
    RESET_USER_SEGMENTS,
    RESET_USER_SEGMENTS_TAGS,
    SEGMENT_PHOTOS_REQUESTED,
    SEGMENT_PHOTOS_SUCCEEDED,
    SEGMENT_PHOTOS_FAILED,
    UPDATE_SEGMENT_NOTES_SUCCEEDED,
    UPDATE_SEGMENT_NOTES_FAILED,
    UPDATE_SEGMENT_NOTES_REQUESTED,
    UPDATE_SEGMENT_NAME_REQUESTED,
    UPDATE_SEGMENT_NAME_SUCCEEDED,
    UPDATE_SEGMENT_NAME_FAILED,
    DELETE_SEGMENT_REQUESTED,
    DELETE_SEGMENT_FAILED,
    DELETE_SEGMENT_SUCCEEDED,
    PARTNERS_REQUESTED,
    PARTNERS_SUCCEEDED,
    PARTNERS_FAILED,
} from './constants';

const initialState = {
    // initial state of user segments to be displayed in segments screen
    segments: [],
    // initial loading state of segments that determines the screen loading
    segmentsLoading: false,
    // determines the id of the active segment at the moment, helps to filter out segmentTags in selector
    activeSegmentId: null,
    // initial state of segment Tags, used to determine which tags to display inside pie chart for each segment
    segmentTags: {},
    // initial state of of segment tags loading
    segmentsTagsLoading: false,
    // current page fetching segments for
    currentPage: 0,
    // current date used to fetch segments for
    date: '',
    landType: '',
    subLandType: '',
    // used to determine if more segments are to be fetched
    hasMoreSegments: true,
    // initial state of loading for lazy loading more segments when last segment is visible
    moreSegmentsLoading: false,
    segmentPhotos: {},
    segmentsPhotosLoading: false,
    savingNotes: false,
    savingSegment: false,
    selectedPartners: [],
    partners: [],
    loadingPartners: false,
    partnerError: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case USER_SEGMENTS_REQUESTED: {
            const { data, attributeName } = action;
            return {
                ...state,
                segments: [], //emtpy out the previous segments
                segmentsLoading: true,
                currentPage: 0,
                [attributeName]: data,
            };
        }
        case MORE_USER_SEGMENTS_REQUESTED: {
            return {
                ...state,
                moreSegmentsLoading: true,
            };
        }
        case USER_SEGMENTS_SUCCEEDED: {
            const { segments } = action;
            return {
                ...state,
                currentPage: state.currentPage + 1,
                hasMoreSegments: segments.length ? true : false,
                segments: [...state.segments, ...segments],
                segmentsLoading: false,
                moreSegmentsLoading: false,
            };
        }
        case USER_SEGMENTS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                segmentsLoading: false,
                moreSegmentsLoading: false,
            };
        }
        case SEGMENT_TAGS_REQUESTED: {
            return {
                ...state,
                segmentsTagsLoading: true,
            };
        }
        case SEGMENT_TAGS_SUCCEEDED: {
            const { segmentTags } = action;
            return {
                ...state,
                segmentTags: { ...state.segmentTags, ...segmentTags }, // combine incoming segment Tags with new action
                segmentsTagsLoading: false,
            };
        }
        case SEGMENT_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                segmentsTagsLoading: false,
            };
        }
        case SET_ACTIVE_SEGMENT: {
            const { activeSegmentId } = action;
            return { ...state, activeSegmentId };
        }
        case RESET_USER_SEGMENTS_TAGS: {
            return {
                ...state,
                segmentTags: {},
                segmentPhotos: {},
                landType: '',
                subLandType: '',
                selectedPartners: [],
            };
        }
        case RESET_USER_SEGMENTS: {
            return initialState;
        }
        case SEGMENT_PHOTOS_REQUESTED: {
            return {
                ...state,
                segmentsPhotosLoading: true,
            };
        }
        case SEGMENT_PHOTOS_SUCCEEDED: {
            const { segmentPhotos } = action;
            return {
                ...state,
                segmentPhotos: { ...state.segmentPhotos, ...segmentPhotos }, // combine incoming segment Photos with new action
                segmentsPhotosLoading: false,
            };
        }
        case SEGMENT_PHOTOS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                segmentsPhotosLoading: false,
            };
        }
        case UPDATE_SEGMENT_NOTES_REQUESTED: {
            return {
                ...state,
                savingNotes: true,
            };
        }
        case UPDATE_SEGMENT_NOTES_SUCCEEDED: {
            const { segment } = action;
            const updatedSegments = [...state.segments];
            const segmentIndex = updatedSegments
                .map((seg) => seg.id)
                .indexOf(segment.id);
            updatedSegments[segmentIndex] = {
                ...updatedSegments[segmentIndex],
                ...segment,
            };
            return {
                ...state,
                segments: [...updatedSegments],
                savingNotes: false,
            };
        }
        case UPDATE_SEGMENT_NOTES_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                savingNotes: false,
            };
        }
        case UPDATE_SEGMENT_NAME_REQUESTED: {
            return {
                ...state,
                savingSegment: true,
            };
        }
        case UPDATE_SEGMENT_NAME_SUCCEEDED: {
            const { segment } = action;
            const updatedSegments = [...state.segments];
            const segmentIndex = updatedSegments
                .map((seg) => seg.id)
                .indexOf(segment.id);
            updatedSegments[segmentIndex] = {
                ...updatedSegments[segmentIndex],
                ...segment,
            };
            return {
                ...state,
                segments: [...updatedSegments],
                savingSegment: false,
            };
        }
        case UPDATE_SEGMENT_NAME_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                savingSegment: false,
            };
        }
        case DELETE_SEGMENT_REQUESTED: {
            return {
                ...state,
                deletingSegment: true,
            };
        }
        case DELETE_SEGMENT_SUCCEEDED: {
            const { segmentId } = action;
            delete state.segmentPhotos[segmentId];
            delete state.segmentTags[segmentId];

            return {
                ...state,
                segments: state.segments.filter((seg) => seg.id != segmentId),
                deletingSegment: false,
            };
        }
        case DELETE_SEGMENT_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                deletingSegment: false,
            };
        }
        case PARTNERS_REQUESTED: {
            return {
                ...state,
                loadingPartners: true,
            };
        }
        case PARTNERS_SUCCEEDED: {
            const { partners } = action;

            return {
                ...state,
                partners,
                loadingPartners: false,
            };
        }
        case PARTNERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                loadingPartners: false,
            };
        }

        default:
            return state;
    }
}
